export default "__VITE_ASSET__2907569f__"